// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/style/main.css
// module id = 251
// module chunks = 1